import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container, Card, Row, Col } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetUsersDetailsQuery,
  useUpdateUserMutation,
} from '../../slices/usersApiSlice';

const UserEditScreen = () => {
  const { id: userId } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [currentSubscriptionUsedItems, setCurrentSubscriptionUsedItems] = useState(0);

  const {
    data: user,
    isLoading,
    refetch,
    error,
  } = useGetUsersDetailsQuery(userId);

  const [updateUser, { isLoading: loadingUpdate }] = useUpdateUserMutation();

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setCurrentSubscriptionUsedItems(user.currentSubscriptionUsedItems || 0);
    }
  }, [user]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateUser({ userId, name, email, currentSubscriptionUsedItems });
      toast.success('User updated successfully');
      refetch();
      navigate('/userlist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Container className="py-4">
        <Link to="/userlist" className="btn btn-light mb-3">
            &larr; Go Back
        </Link>

        <FormContainer>
            <Card className="shadow-sm p-4">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">User Management</h4>
                    {loadingUpdate && <Loader size="sm" />}
                </Card.Header>
                <Card.Body>
                    {/* <h2 className="mb-4 text-center">Edit User</h2> */}

                    {loadingUpdate && <Loader />}
                    {isLoading ? (
                        <Loader />
                    ) : error ? (
                        <Message variant="danger">{error}</Message>
                    ) : (
                        <Form onSubmit={submitHandler}>
                            <Row className="mb-3">
                            <Col md={6} className="mb-3">
                                <Form.Group controlId="name">
                                <Form.Label>名前</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                    <Form.Group controlId="email">
                                    <Form.Label>メール</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    </Form.Group>
                            </Col>
                            </Row>

                            <Form.Group controlId="currentSubscriptionUsedItems" className="mb-4">
                                <Form.Label>サブスクレンタル着数</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={currentSubscriptionUsedItems}
                                    onChange={(e) => setCurrentSubscriptionUsedItems(Number(e.target.value))}
                                    placeholder="0"
                                />
                                <Form.Text className="text-muted">
                                    Enter the number of items the user has used in their current subscription.
                                </Form.Text>
                            </Form.Group>

                            <div className="d-grid">
                                <Button type="submit" variant="primary" size="lg">
                                    更新
                                </Button>
                            </div>
                        </Form>
                    )}
                </Card.Body>
            </Card>
        </FormContainer>
    </Container>
  );
};

export default UserEditScreen;